const Subscription = {
  EDIT_SUBSCRIPTION: 'subscription/edit',
}

export default Subscription;
